import { render, staticRenderFns } from "./SiteNotAvailableTid6-gt2.vue?vue&type=template&id=5b957b67&scoped=true"
import script from "./SiteNotAvailableTid6-gt2.vue?vue&type=script&lang=js"
export * from "./SiteNotAvailableTid6-gt2.vue?vue&type=script&lang=js"
import style0 from "./SiteNotAvailableTid6-gt2.vue?vue&type=style&index=0&id=5b957b67&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b957b67",
  null
  
)

export default component.exports